import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=3ddabd5e&scoped=true&"
import script from "./UserGrid.vue?vue&type=script&lang=ts&"
export * from "./UserGrid.vue?vue&type=script&lang=ts&"
import style0 from "./UserGrid.vue?vue&type=style&index=0&id=3ddabd5e&prod&lang=css&"
import style1 from "./UserGrid.vue?vue&type=style&index=1&id=3ddabd5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddabd5e",
  null
  
)

export default component.exports